export default __webpack_public_path__ + "static/media/BANNER CABECERA.aa267dbf.png";